/* Elora — FAQ tabs + accordion. Ports the mock's faq block, scoped to the section. */
(function () {
  var Elora = (window.Elora = window.Elora || {});

  function initRoot(root) {
    if (root.hasAttribute('data-elora-faq-ready')) return;
    root.setAttribute('data-elora-faq-ready', '');

    var panelbox = root.querySelector('[data-elora-faq-panels]');
    if (!panelbox) return;

    var tablist = root.querySelector('[data-elora-faq-tabs]');
    var tabs = tablist ? Array.prototype.slice.call(tablist.querySelectorAll('.faq__tab')) : [];
    var panels = Array.prototype.slice.call(panelbox.querySelectorAll('.faq__panel'));
    var items = Array.prototype.slice.call(panelbox.querySelectorAll('.faq__item'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 1;
    var busy = false;

    function topOf(item) {
      return item.querySelector('.faq__top');
    }

    function setOpen(btn, on) {
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (body) {
        if (on) {
          body.removeAttribute('inert');
        } else {
          body.setAttribute('inert', '');
        }
      }
    }

    /* Without JS every answer is open and readable; the script closes them. */
    items.forEach(function (item) {
      var btn = topOf(item);
      if (btn) setOpen(btn, false);
    });

    items.forEach(function (item) {
      var btn = topOf(item);
      if (!btn) return;
      item.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('a[href]')) return;
        setOpen(btn, btn.getAttribute('aria-expanded') !== 'true');
      });
    });

    if (!tabs.length) return;

    function paneBy(n) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-p') === String(n)) return panels[i];
      }
      return null;
    }

    function mark(n) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-t') === String(n);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function focusTab(n) {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('data-t') === String(n)) {
          tabs[i].focus();
          return;
        }
      }
    }

    function go(n, focus) {
      if (busy || n === cur) {
        if (focus) focusTab(n);
        return;
      }
      var from = paneBy(cur);
      var to = paneBy(n);
      if (!to) return;
      cur = n;
      mark(n);
      if (focus) focusTab(n);
      if (!from || from === to || reduce) {
        if (from && from !== to) from.setAttribute('hidden', '');
        to.removeAttribute('hidden');
        to.classList.remove('is-out');
        return;
      }
      busy = true;
      from.classList.add('is-out');
      setTimeout(function () {
        from.setAttribute('hidden', '');
        from.classList.remove('is-out');
        to.classList.add('is-out');
        to.removeAttribute('hidden');
        to.getBoundingClientRect();
        to.classList.remove('is-out');
        busy = false;
      }, 100);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        go(parseInt(t.getAttribute('data-t'), 10), false);
      });
      t.addEventListener('keydown', function (e) {
        var k = e.key;
        var n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = cur + 1 > tabs.length ? 1 : cur + 1;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = cur - 1 < 1 ? tabs.length : cur - 1;
        else if (k === 'Home') n = 1;
        else if (k === 'End') n = tabs.length;
        if (n === null) return;
        e.preventDefault();
        go(n, true);
      });
    });

    mark(1);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(root.querySelectorAll('[data-elora-faq]')).forEach(initRoot);
    if (root.matches && root.matches('[data-elora-faq]')) initRoot(root);
  }

  Elora.faq = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
